export default function roundToFixed(num, fixed = 2) {
  let exp = 10 ** fixed // e.g. "100"
  // Number.EPSILON
  let o = Math.round((num + Number.EPSILON) * exp) / exp
  return o.toFixed(fixed)
}
